import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, SubjectLocationItem } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

type SubjectLocationType = 'candidate' | 'patient' | 'carepartner' | 'all'

export const useSubjectLocations = (type: SubjectLocationType = 'all') => {
    const [items, setItems] = useState<SubjectLocationItem[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchSubjectLocations = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<SubjectLocationItem[]> = AspenDashboardService.getSubjectLocationsDashboardSubjectLocationsGet({
                type
            })
            const data = await response
            setItems(data)
        } catch (err) {
            setError('Failed to fetch subject locations')
            enqueueSnackbar('Failed to fetch subject locations', { variant: 'error' })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar, type])

    useEffect(() => {
        fetchSubjectLocations()
    }, [fetchSubjectLocations])

    return { items, loading, error, fetchSubjectLocations }
}
